import { Injectable } from '@angular/core';

/**
 * Inscription à la liste de diffusion Zoho Campaigns (la « base » des offres
 * exclusives). Partagée par la page /subscribe et le pop-up d'accueil.
 * Zoho autorise l'appel direct depuis www.luxuryholidaysdirect.com (CORS).
 */
@Injectable({
  providedIn: 'root',
})
export class NewsletterService {
  readonly zohoConfig = {
    scriptUrl: 'https://svgjn-zcmp.maillist-manage.eu/js/optin.min.js',
    formId:
      'sf3zdcf2b757947f0a3096ba07ae77f99897cb1ca790280bb3aaec47ccd69fde92b5',
    actionUrl: 'https://svgjn-zcmp.maillist-manage.eu/weboptin.zc',
    zx: '14aeb9584c',
    zctd: '13a5b1364a112541',
    zc_formIx:
      '3zdcf2b757947f0a3096ba07ae77f99897cb1ca790280bb3aaec47ccd69fde92b5',
  };

  async subscribe(name: string, email: string): Promise<void> {
    const formData = new URLSearchParams({
      CONTACT_EMAIL: email,
      LASTNAME: name,
      submitType: 'optinCustomView',
      emailReportId: '',
      formType: 'QuickForm',
      zx: this.zohoConfig.zx,
      zcvers: '2.0',
      oldListIds: '',
      mode: 'OptinCreateView',
      zcld: '',
      zctd: this.zohoConfig.zctd,
      document_domain: '',
      zc_Url: 'svgjn-zcmp.maillist-manage.eu',
      new_optin_response_in: '0',
      duplicate_optin_response_in: '0',
      zc_trackCode: 'ZCFORMVIEW',
      zc_formIx: this.zohoConfig.zc_formIx,
      viewFrom: 'URL_ACTION',
    });

    const response = await fetch(this.zohoConfig.actionUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData.toString(),
    });

    if (!response.ok) {
      throw new Error(
        `Zoho subscription request failed with status ${response.status}`,
      );
    }
  }
}
